<template>
  <el-container class="IncomeTradePrint">
    <el-main ref="IncomeTradePrintArea" class="p-0 IncomeTradePrintArea" :class="{ 'is-landscape': isLandscape }">
      <div
        v-for="(sdata, index) in slice_items"
        class="w-full print-divider pb-default"
        :key="sdata.id"
      >
        <!-- 엑셀 파일 출력으로 인해 style 태그 적용 -->
        <div id="excel_table">
          <table class="w-full">
            <tr>
              <td
                colspan="10"
                style="font-size:35px; font-weight:bold; text-align:center;"
              >거 래 명 세 서</td>
            </tr>
            <tr>
              <td colspan="10" style="font-size:15px;">{{bankAccountId}} 예금주 {{company.name}}</td>
            </tr>
          </table>
          <table
            class="w-full border transaction"
            cellspacing="0"
            cellpadding="2"
            style="border-bottom:none;"
          >
            <col width="2%" />
            <col width="8%" />
            <col width="15%" />
            <col width="8%" />
            <col width="17%" />
            <col width="2%" />
            <col width="8%" />
            <col width="15%" />
            <col width="8%" />
            <col />
            <tr>
              <!-- 공급받는자 -->
              <th rowspan="4">공 급 받 는 자</th>
              <th>발행일</th>
              <td colspan="3" style="text-align:left;">{{util.getDate()}}</td>
              <!-- 공급자 -->
              <th rowspan="4">공 급 자</th>
              <th style="min-width: 70px;">등록번호</th>
              <td colspan="3">{{company.crn}}</td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>소재지</th>
              <td colspan="3">{{customer.addr}}</td>
              <!-- 공급자 -->
              <th>소재지</th>
              <td colspan="3">
                <AFitText>{{company.addr}}</AFitText>
              </td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>상 호</th>
              <td colspan="3">{{customer.name}}</td>
              <!-- 공급자 -->
              <th>상호</th>
              <td style="min-width: 180px;">{{company.name}}</td>
              <th style="min-width: 70px;">대표자</th>
              <td>{{company.owner}}</td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>연락처</th>
              <td style="min-width: 100px;">{{customer.tel}}</td>
              <th style="min-width: 40px;">팩 스</th>
              <td style="min-width: 70px;">{{customer.fax}}</td>
              <!-- 공급자 -->
              <th>전 화</th>
              <td>{{company.tel}}</td>
              <th>팩 스</th>
              <td>{{company.fax}}</td>
            </tr>
            <tr></tr>
          </table>
          <div class="none">
            <table
              class="w-full border table-fs12 print-list transaction table-fixed"
              cellspacing="0"
              cellpadding="3"
            >
              <col :width="isLandscape ? 85 : 100" />
              <col :width="isLandscape ? 120 : 230" />
              <col :width="isLandscape ? 80 : 100" />
              <col :width="isLandscape ? 55 : 60" />
              <col :width="isLandscape ? 30 : 40" />
              <col :width="isLandscape ? 30 : 40" />
              <col v-if="isTotalPyung" :width="isLandscape ? 55 : 60" />
              <col :width="isLandscape ? 65 : 90" />
              <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 90" />
              <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 90" />
              <col :width="isLandscape ? 80 : 90" />
              <col :width="isLandscape ? 65 : 90" />
              <col :width="isLandscape ? 80 : 90" />
              <col />
              <tr>
                <th>거래일</th>
                <th>품목</th>
                <th>{{$t('lang.size')}}</th>
                <th>평</th>
                <th>수량</th>
                <th>단위</th>
                <th v-if="isTotalPyung">총평수</th>
                <th>단가</th>
                <th v-if="showPyungProcessingCost">평단가</th>
                <th v-if="showPyungProcessingCost">가공비</th>
                <th>공급가액</th>
                <th>세액</th>
                <th>금액</th>
                <th>비고</th>
              </tr>
              <tr
                v-for="item in data"
                v-bind:key="item.id"
                :class="[
                  {
                    mark: item.type_flag === '2',
                    'day-sum-row' : item.sum_row,
                    total: item.is_total,
                    'landscape-font': isLandscape
                  },
                ]"
              >
                <td style="text-align:center;">{{item.type_flag === '2' ? item.deal_date : company.invoice_type ==='order' ? item.contract_date : item.deal_date }}</td>
                <td class="mark">{{item.product_name}}</td>
                <td>
                  <div class="ellipsis">{{item.size}}</div>
                </td>
                <td>{{isGlass(item,item.size)}}</td>
                <td class="align-center">{{util.addComma(item.amount)}}</td>
                <td class="align-center mark">{{item.unit_name}}</td>
                <td v-if="isTotalPyung">{{isGlassTotalPyung(item,item.size)}}</td>
                <td class="cell-number">{{util.addComma(item.cost)}}</td>
                <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.pyung_cost)}}</td>
                <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.item_processing_cost)}}</td>
                <td class="cell-number total">{{util.addComma(item.supply_price)}}</td>
                <td class="cell-number total">{{util.addComma(item.tax)}}</td>
                <td class="cell-number mark">{{util.addComma(item.price)}}</td>
                <td>
                  <div class="ellipsis">{{(item.desc ? item.desc : '') + `${isShowField ? `${item.field ? ` (${item.field})` : ''}` : ""}`}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="w-full mt-default">
          <table
            class="w-full border table-fs12 print-list transaction table-fixed"
            cellspacing="0"
            cellpadding="3"
          >
            <col :width="isLandscape ? 85 : 100" />
            <col :width="isLandscape ? 120 : 230" />
            <col :width="isLandscape ? 80 : 100" />
            <col :width="isLandscape ? 55 : 60" />
            <col :width="isLandscape ? 30 : 40" />
            <col :width="isLandscape ? 30 : 40" />
            <col v-if="isTotalPyung" :width="isLandscape ? 60 : 60" />
            <col :width="isLandscape ? 65 : 90" />
            <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 90" />
            <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 90" />
            <col :width="isLandscape ? 80 : 90" />
            <col :width="isLandscape ? 65 : 90" />
            <col :width="isLandscape ? 80 : 90" />
            <col />
            <tr>
              <th>거래일</th>
              <th>품목</th>
              <th>{{$t('lang.size')}}</th>
              <th>평</th>
              <th>수량</th>
              <th>단위</th>
              <th v-if="isTotalPyung">총평수</th>
              <th>단가</th>
              <th v-if="showPyungProcessingCost">평단가</th>
              <th v-if="showPyungProcessingCost">가공비</th>
              <th>공급가액</th>
              <th>세액</th>
              <th>금액</th>
              <th>비고</th>
            </tr>
            <tr
              v-for="(item, i) in sdata.items"
              :key="item.id"
              :class="[
                {
                  mark: item.type_flag === '2',
                  'day-sum-row' : item.sum_row,
                  total: item.is_total,
                  'landscape-font': isLandscape
                },
              ]"
            >
              <!-- <td style="text-align:center;">{{displayDealDate(index, i)}}</td> -->
              <td style="text-align:center;">{{displayDealDate(index, i, company.invoice_type)}}</td>
              <td class="mark">{{item.product_name}}</td>
              <td>{{item.size}}</td>
              <td class="total">{{item.is_last ? '' : isGlass(item,item.size)}}</td>
              <td class="align-center">{{util.addComma(item.amount)}}</td>
              <td class="align-center mark">{{item.unit_name}}</td>
              <td v-if="isTotalPyung" class="total">{{item.item_pyung ? item.item_pyung : isGlassTotalPyung(item,item.size)}}</td>
              <td class="cell-number">{{util.addComma(item.cost)}}</td>
              <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.pyung_cost)}}</td>
              <td v-if="showPyungProcessingCost" class="cell-number mark">{{util.addComma(item.item_processing_cost)}}</td>
              <td class="cell-number total">{{util.addComma(item.supply_price)}}</td>
              <td class="cell-number total">{{util.addComma(item.tax)}}</td>
              <td class="cell-number mark">{{util.addComma(item.price)}}</td>
              <td>
                <div class="ellipsis">{{(item.desc ? item.desc : '') + `${isShowField ? `${item.field ? ` (${item.field})` : ''}` : ""}`}}</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="w-full mt-default flex-space-between">
          <table class="w-full border transaction table-account" cellpadding="5">
            <tr>
              <th>전잔액</th>
              <td width="100" class="cell-number">{{util.addComma(sdata.account.pre_balance)}}</td>
              <th>입금액</th>
              <td width="100" class="cell-number">{{util.addComma(sdata.account.collect)}}</td>
              <th>소 계</th>
              <td width="100" class="cell-number">{{util.addComma(sdata.account.total)}}</td>
              <th>현잔액</th>
              <td width="100" class="cell-number">{{util.addComma(sdata.account.balance)}}</td>
              <th>인수자</th>
              <td width="100"></td>
            </tr>
          </table>
        </div>
        <div class="w-full mt-default flex-space-between">
          <span class="text-danger">{{$t('lang.software_consulting')}}</span>
          <span class="text-danger">{{$t('lang.homepage')}}</span>
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button type="primary" @click="handleClickPrint">발 행</el-button>
      <el-button @click="handleClickExcel">양식 다운로드</el-button>
      <el-button @click="handlClickBomExcel">데이터 다운로드</el-button>
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { company_info } from "@/common/mixins/company_info";
import AFitText from "@/shared/AFitText";
import Print from "@/plugins/print/print";
import export2csv from "@/common/function/export2csv";

Vue.use(Print);

export default {
  name: "IncomeTradePrint",
  components: { AFitText },
  mixins: [company_info],
  data() {
    return {
      company: {
        income_trade_print_type: 'portrait',
        show_pyung_processing_cost: false,
        income_trade_print_field: false,
        income_trade_print_pyung: false,
      },
      title: this.$t("title.trade"),
      result: null,
      items: [],
      is_printed: false
    };
  },
  props: {
    period: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    sum_flag: {
      type: Boolean
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    ...mapGetters(["table_config", "table_account"]),
    isLandscape() {
      return this.company.income_trade_print_type === "landscape";
    },
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    isShowField() {
      return this.company.income_trade_print_field;
    },
    isTotalPyung() {
      return this.company.income_trade_print_pyung;
    },
    slice_items() {
      let items = [];
      let cur_items;
      let index = 0;
      let total_tax = 0;
      let total_supply_price = 0;
      let total_item_processing_cost = 0;
      let total_price = 0;
      let total_pyung = 0;
      this.items.forEach(item => {
        if ((index % (this.isLandscape ? 10 : 30)) === 0) {
          cur_items = {
            id: index,
            items: []
          };
          items.push(cur_items);
        }
        cur_items.items.push(item);
        index++;
        if(item.type_flag === '1'){
          total_pyung += Number(this.isGlassTotalPyung(item,item.size))
          total_tax += item.tax || 0;
          total_supply_price += item.supply_price || 0;
          total_item_processing_cost += item.item_processing_cost || 0;
          total_price += item.price || 0;
        }
      });
      items.forEach(item => {
        item.account = this.parseAccount(item);
      });
      if(this.company.is_total && items.length){
        items[items.length-1].items.push({
          is_last: true,
          deal_date: null,
          contract_date: null,
          product_name: "합계",
          item_pyung: this.isTotalPyung ? total_pyung.toFixed(2) : '',
          tax: total_tax,
          supply_price: total_supply_price,
          item_processing_cost: total_item_processing_cost,
          price: total_price,
          is_total: true
        })
      }
      return items;
    },
    bankAccountId() {
      let account_id = this.customer.account_id;
      if (!account_id) {
        let item = this.table_config.find(c => c.key === "account");
        account_id = item.value.represent;
      }
      let account = this.table_account.find(o => o.id === account_id);
      return account ? account.bank_name + " " + account.number : "";
    }
  },
  mounted() {
    this.loadConfig();
    this.calculatePrice();
  },
  methods: {
    calculatePrice() {
      this.items = Object.assign([], this.data);
      if (this.sum_flag === true) {
        let day_old = "";
        let day_cur = "";
        let day_supply_price = 0;
        let day_tax = 0;
        let day_price = 0;
        let day_balance = 0;
        let day_pyung = 0;
        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i];
          day_cur = item.deal_date;
          if (day_old !== day_cur) {
            if (day_old !== "") {
              this.items.splice(i, 0, {
                sum_row: true,
                deal_date: day_old,
                product_name: "소 계",
                supply_price: day_supply_price,
                item_pyung: day_pyung.toFixed(2),
                tax: day_tax,
                price: day_price,
                balance: day_balance
              });
              day_pyung = 0;
              day_supply_price = 0;
              day_tax = 0;
              day_price = 0;
              day_balance = 0;
              i++;
            }
            day_old = day_cur;
          }
          if (item.type_flag === "1") {
            day_supply_price += item.supply_price;
            day_tax += item.tax;
            day_price += item.price;
            day_pyung += Number(this.isGlassTotalPyung(item, item.size))
          }
          day_balance = item.balance;
        }
        if (
          this.items.length > 0 &&
          !this.items[this.items.length - 1].sum_row
        ) {
          this.items.splice(this.items.length + 1, 0, {
            sum_row: true,
            deal_date: day_old,
            product_name: "소 계",
            supply_price: day_supply_price,
            item_pyung: day_pyung.toFixed(2),
            tax: day_tax,
            price: day_price,
            balance: day_balance
          });
        }
      }
    },
    displayDealDate(sIndex, index, invoice_type) {
      let sItem = this.slice_items[sIndex];
      if(sItem.items[index].type_flag === '2') return sItem.items[index].deal_date
      let trading_date = invoice_type === 'order' ? sItem.items[index].contract_date : sItem.items[index].deal_date;
      
      if(!trading_date) return;
      if (index === 0) {
        return trading_date;
      }
      let last_trading_date = invoice_type === 'order' ? sItem.items[index - 1].contract_date : sItem.items[index - 1].deal_date
      if (last_trading_date === trading_date) {
        if (sItem.items[index].sum_row) {
          return trading_date;
        }
        return "''";
      } else {
        return trading_date;
      }
    },
    doRegister() {
      // let supply_price = 0;
      // let tax = 0;
      // let price = 0;
      // let billed_price = 0;
      // let seq = 1;
      let sales = [];
      let collects = [];
      this.data.forEach(item => {
        // if (item.type_flag === "2") {
        //   if (item.price) {
        //     billed_price += item.price;
        //   }
        // } else {
        //   if (item.supply_price) {
        //     supply_price += item.supply_price;
        //   }
        //   if (item.tax) {
        //     tax += item.tax;
        //   }
        //   if (item.price) {
        //     price += item.price;
        //   }
        if (item.type_flag === "2") {
          collects.push(item.collect_id);
        } else {
          sales.push(item.sale_id);
        }
      });
      let data = {
        sales: sales,
        collects: collects
      };
      this.api.registerIncomeTransaction(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.result = true;
        this.doPrint();
      });
    },
    doPrint() {
      const id = 'print-orientation-style';
      document.getElementById(id)?.remove();
      const s = document.createElement('style');
      s.id = id;
      s.media = 'print';
      s.textContent = `@page { size: ${this.isLandscape ? 'landscape' : 'portrait'}; }`;
      document.head.appendChild(s);

      this.is_printed = true;
      this.$print(this.$refs.IncomeTradePrintArea);

      setTimeout(() => document.getElementById(id)?.remove(), 0);
    },
    handleClickPrint() {
      if (this.result) {
        this.doPrint();
      } else {
        this.util.confirm(
          this,
          this.title,
          "발행하시겠습니까?",
          this.doRegister
        );
      }
    },
    handleClickClose() {
      this.$emit("completed", this.is_printed);
    },
    parseAccount(data) {
      let pre_balance = this.items[0].balance - this.items[0].price;
      let balance = this.items[this.items.length - 1].balance;
      let collect = 0;
      let total = 0;
      if (this.items[0].sum_row) {
        // 첫 번쨰 행이 소계라면
        pre_balance = this.items[0].balance;
      }
      if (this.items[0].type_flag === "2") {
        // 첫 번째 행이 수금이라면
        pre_balance = this.items[0].balance + this.items[0].price;
      }
      this.items.forEach(item => {
        if (item.collect_price) {
          collect += item.collect_price;
        }
        if (item.type_flag === "1") {
          total += item.price;
        }
      });
      if (this.items.length !== data.items.length + data.id) {
        pre_balance = null;
        collect = null;
        total = null;
        balance = null;
      }
      return {
        pre_balance: pre_balance,
        collect: collect,
        total: total,
        balance: balance
      };
    },
    handlClickBomExcel() {
      let items = [];
      let fields = [
        { value: "deal_date", label: "거래일" },
        { value: "product_name", label: "품목" },
        { value: "size", label: "규격" },
        { value: "pyung", label: "평" },
        { value: "amount", label: "수량" },
        { value: "unit_name", label: "단위" },
        { value: "item_pyung", label: "총평수" },
        { value: "cost", label: "단가" },
        { value: "supply_price", label: "공급가액" },
        { value: "tax", label: "세액" },
        { value: "price", label: "금액" },
        { value: "desc", label: "비고" }
      ];
      this.data.forEach(d => {
        let data = {
          deal_date: d.deal_date,
          product_name: d.product_name,
          size: d.size,
          pyung: this.isGlass(d, d.size),
          amount: d.amount,
          unit_name: d.unit_name,
          item_pyung: this.isGlassTotalPyung(d, d.size),
          cost: d.cost,
          supply_price: d.supply_price,
          tax: d.tax,
          price: d.price,
          desc: d.desc
        };
        items.push(data);
      });
      export2csv.export(items, fields, "거래명세서");
    },
    handleClickExcel() {
      let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text +=
        '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      tab_text += "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text += "<x:Name>" + this.title + "</x:Name>";
      tab_text +=
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text += "<table>";
      const temp = document.getElementById("excel_table").innerHTML;
      tab_text += temp;
      tab_text += "</table></body></html>";
      const fileName = this.title + ".xls";
      const a_tag = document.createElement("a");
      const blob = new Blob([tab_text], {
        type: "application/vnd.ms-excel;charset=utf-8;"
      });
      a_tag.href = window.URL.createObjectURL(blob);
      a_tag.download = fileName;
      a_tag.click();
    },
    isGlass(row, value) {
      if (row.product_kind === "GLASS" && row.size) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map(x => Number(x));
        const return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    },
    isGlassTotalPyung(row, value) {
      if (row.product_kind === "GLASS" && row.size) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map(x => Number(x));
        let return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : ((return_value < 3 ? 3 : return_value) * row.amount).toFixed(2);
      }
      return "";
    }
  }
};
</script>
<style lang="scss">
.IncomeTradePrint {
  .table-account {
    tr {
      th {
        width: 80px;
      }
      td {
        min-width: 100px;
      }
    }
  }
}
.landscape-font td,
.landscape-font th {
  font-size: 12px !important;
}
</style>
<style lang="scss" media="print">
/* 1) 기본값: A4 세로 */
@page { size: portrait; }

/* 2) 네임드 페이지: A4 가로 */
@page landscape { size: landscape; }

/* 3) is-landscape 클래스일 때만 가로 적용 */
.IncomeTradePrintArea.is-landscape { page: landscape; }

/* 4) 나머지 기존 프린트 스타일 유지 */
.IncomeTradePrintArea {
  table.table-fs12 .day-sum-row { height: 30px; line-height: 30px; }
  table.table-fs12 tr th,
  table.table-fs12 tr td,
  table.transaction tr td,
  table.transaction tr th,
  .el-dialog__body { font-size: 15px; }
  .landscape-font > td { font-size: 14px !important; }
}
</style>